module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "playerContainer",
    staticClass: "tengxunyun",
    class: {
      'tengxunyun-horizontal': _vm.screenType === 1
    }
  }, [_c('video', {
    staticClass: "tengxunyun-video",
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "id": _vm.playerId,
      "preload": "auto",
      "playsinline": "",
      "webkit-playsinline": ""
    }
  }), _vm._v(" "), (_vm.isShowCover && _vm.backgroundUrl) ? _c('div', {
    staticClass: "video-cover"
  }, [_c('div', {
    staticClass: "video-cover-box"
  }, [_c('img', {
    staticClass: "video-cover-box-img",
    attrs: {
      "src": _vm.backgroundUrl,
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.show_svga) ? _c('playSvga', {
    ref: "svga"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57eb2ee1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tengxunyun/tengxunyun.vue
// module id = 1023
// module chunks = 1